import { WarningSection } from './types'

/**
 * Canonical required warning fields per section.
 * Keep these aligned with ValidationSchema.tsx.
 */
export const REQUIRED_WARNING_FIELDS = {
  profile: {
    firstName: 'firstName',
    lastName: 'lastName',
  },
  skills: {
    skillId: 'skillId',
    level: 'level',
    interestLevel: 'interestLevel',
    experienceMonths: 'experienceMonths',
    lastUsed: 'lastUsed',
  },
  industries: {
    skillId: 'skillId',
    level: 'level',
    interestLevel: 'interestLevel',
    experienceMonths: 'experienceMonths',
    lastUsed: 'lastUsed',
  },
  roles: {
    skillId: 'skillId',
    level: 'level',
    interestLevel: 'interestLevel',
    experienceMonths: 'experienceMonths',
    lastUsed: 'lastUsed',
  },
  employers: {
    startDate: 'startDate',
    name: 'name',
    description: 'description',
  },
  projects: {
    startDate: 'startDate',
    customerName: 'customerName',
    employerName: 'employerName',
    name: 'name',
    description: 'description',
  },
  education: {
    startDate: 'startDate',
    dateResolution: 'dateResolution',
    degree: 'degree',
    school: 'school',
  },
  courses: {
    startDate: 'startDate',
    dateResolution: 'dateResolution',
    course: 'course',
    organizer: 'organizer',
  },
  certificates: {
    issueDate: 'issueDate',
    dateResolution: 'dateResolution',
    certificateId: 'certificateId',
    certifier: 'certifier',
  },
  competences: {
    issueDate: 'issueDate',
    dateResolution: 'dateResolution',
    competenceId: 'competenceId',
    issuer: 'issuer',
  },
  references: {
    firstName: 'firstName',
    lastName: 'lastName',
    company: 'company',
    letter: 'letter',
  },
  languages: {
    languageCode: 'languageCode',
    level: 'level',
  },
} as const

/**
 * Optional fields intentionally excluded from warning checks.
 * This documents non-blocking fields and keeps scope explicit.
 */
export const OPTIONAL_WARNING_FIELDS: Partial<Record<WarningSection, readonly string[]>> = {
  employers: ['endDate', 'primaryRole', 'EmployerRoles'],
  projects: ['endDate', 'primaryRole', 'ProjectRoles'],
  education: ['endDate', 'description'],
  courses: ['endDate', 'description'],
  certificates: ['endDate', 'licenceNumber', 'url', 'description'],
  competences: ['endDate', 'description'],
}
